export enum TTVRPlanningEntityKind {
  Leaflet = 'leaflet',
  Papillary = 'papillary',
  Commissure = 'commissure'
}

export function parseTTVRPlanningEntityKind(str: string): TTVRPlanningEntityKind {
  for (const kind of Object.values(TTVRPlanningEntityKind)) {
    if (kind == str) {
      return kind;
    }
  }
  throw new Error('Unknown TTVRPlanningEntityKind literal');
}
